import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

export const onRouteUpdate = () => {
  if (typeof document !== "undefined") {

    /* ===== fadeIn ===== */
    const elements = document.querySelectorAll(".fadeInUp, .fadeIn")

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on")
          }
        })
      },
      { threshold: 0.1 }
    )

    elements.forEach((el) => observer.observe(el))


    /* ===== セクション用 ===== */
    const sections = document.querySelectorAll(
      ".indexPage .interviewSec, .indexPage .aboutSec, .indexPage .jobSec"
    )

    const sectionObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("run")
          }
        })
      },
      { threshold: 0.2 }
    )

    sections.forEach((el) => sectionObserver.observe(el))


    return () => {
      elements.forEach((el) => observer.unobserve(el))
      sections.forEach((el) => sectionObserver.unobserve(el))
    }
  }
}

export const onClientEntry = () => {
  if (typeof document !== "undefined") {
    document.documentElement.classList.add("js")
  }
}